import React, { FC } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { ReduxState } from 'app/redux/types';

import { getSportKey } from 'app/lib/betting/sport-utils';

import { RecordOfSportEntryType } from '../../../records';
import { selectSports } from '../../../selectors/entries';
import Match from '../Match';

import styles from './Sport.module.scss';

// ---

type StoreProps = {
  showSportName: boolean;
  matchIds?: RecordOfSportEntryType['matchIds'];
  sportName?: string;
  sportKey?: string;
};

type SportProps = {
  sportId: number;
};

const Sport: FC<SportProps & StoreProps> = ({
  showSportName,
  matchIds,
  sportName,
  sportKey,
}) => {
  return (
    <>
      {showSportName && (
        <div className={classNames(styles.sport, sportKey && styles[sportKey])}
             data-test="sport-name">
          {sportName}
        </div>
      )}
      {matchIds?.map((matchId) => (
        <Match key={matchId}
               matchId={matchId} />
      ))}
    </>
  );
};

const mapStateToProps = (state: ReduxState, { sportId }: SportProps): StoreProps => {
  const sports = selectSports(state);
  const sport = sports.get(sportId);

  return {
    matchIds: sport?.matchIds,
    showSportName: sports.size > 1,
    sportName: sport?.entity.name,
    sportKey: getSportKey(sportId),
  };
};

export default connect(mapStateToProps)(Sport);
